import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { ProfileProvider } from './contexts/ProfileContext';
import { ToastProvider } from './contexts/ToastContext';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './components/ui/ErrorFallback';
import './i18n/i18n';
import './assets/styles/index.css';

// Only log web vitals in development
const logWebVitals =
  process.env.NODE_ENV === 'development'
    ? // eslint-disable-next-line no-console
      console.log
    : undefined;

const container = document.getElementById('root');
const root = createRoot(container);

const renderApp = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <BrowserRouter>
        <AuthProvider>
          <ProfileProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </ProfileProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

root.render(renderApp());

// Report web vitals
reportWebVitals(logWebVitals);
